import { styled } from "sharedUI/styles";

export const PortalWrapperContainer = styled.div`
    & > * {
        pointer-events: initial;
    }
`;
